import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import DefaultLayout from "layouts/Default";
import RouteURLs from "RouteURLs";
import { logPageView } from "services/analytics";
import "./index.scss";
import { Space } from "services/entities/spaces";
import { loadSpace } from "services/spaces";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";
import TabbedNavigation from "components/tabbedNavigation/tabbedNavigation";
import PanelWhy from "components/panelWhy";
import PanelLocation from "components/panelLocation";
import PanelTour from "components/panelTour";
import PanelChoose from "components/panelChoose";
import SpaceDetailCarousel from "components/SpaceDetailCarousel";
import PanelFaqs from "components/panelFaqs";

export interface ViewSpacePageState {
  space: Space | null;
}

export class ViewSpacePageBase<
  ST extends ViewSpacePageState = ViewSpacePageState
> extends Component<RouteComponentProps<{ slug: string }>, ST> {
  static MAX_GALLERY_IMAGES = 5;

  state: ST = {
    space: null,
  } as ST;

  get elementID(): string {
    return "view-space-page";
  }

  componentDidMount(): void {
    if (!this.props.match.params.slug) {
      this.props.history.replace(RouteURLs.NOT_FOUND);
      return;
    }
    this.setSpace(this.props.match.params.slug);
  }

  componentDidUpdate(
    prevProps: Readonly<RouteComponentProps<{ slug: string }>>,
    prevState: Readonly<ViewSpacePageState>,
    snapshot?: any
  ): void {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      this.setState({ space: null });
      this.setSpace(this.props.match.params.slug);
    }
  }

  setSpace(code: string) {
    loadSpace(code).then(
      (space) => {
        logPageView(this.props.location.pathname, `View Space - ${space.name}`);
        this.setState({ space: space });
      },
      () => this.props.history.replace(RouteURLs.NOT_FOUND)
    );
  }

  onTourClick = () => {
    const space: Space | null = this.state.space;
    if (space && space!.tourURL) {
      window.open(space!.tourURL);
    }
  };

  onDesignClick = () => {
    this.props.history.push(RouteURLs.NEW_DESIGN);
  };

  render() {
    const space: Space | null = this.state.space;

    if (!space) {
      return (
        <DefaultLayout id={this.elementID}>
          <span />
        </DefaultLayout>
      );
    }

    return (
      <DefaultLayout id={this.elementID} pageData={space}>
        <SpaceDetailCarousel space={space} />
        <BookingEnquiryForm space={space.code} samplePrice={space.samplePrice?.amount} />

        {
          <TabbedNavigation
            tabs={{
              items: [
                {
                  tabTitle: "tab 1",
                  label: `Why ${space.name}`,
                },
                {
                  tabTitle: "tab 2",
                  label: "Take the tour",
                },
                {
                  tabTitle: "tab 3",
                  label: "Location",
                },
                {
                  tabTitle: "tab 4",
                  label: "Sookcess Stories",
                },
                {
                  tabTitle: "tab 5",
                  label: "FAQ",
                },
              ],
            }}
          >
            <PanelChoose
              space={space}
              sectionTitle={`Why Choose ${space.name}`}
              text={space.description}
              key="panel-choose"
            />
            <PanelWhy
              title={`The power of Sook<br/> ${space.name}`}
              sectionTitle={`Facilities`}
              space={space}
              titleVariant="h2"
              key="panel-why"
            />
            <PanelTour
              space={space}
              title={space.tourDescription}
              sectionTitle={
                space.tourURL || space.tourDescription
                  ? "Explore this Space"
                  : ""
              }
              titleVariant="h2"
              key="panel-tour"
            />
            <PanelLocation
              space={space}
              sectionTitle={`Location`}
              titleVariant="h2"
              key="panel-location"
            />
            <PanelFaqs
              space={space}
              sectionTitle="Your questions Answered"
              titleVariant="h2"
              key="panel-faq"
            />
          </TabbedNavigation>
        }
      </DefaultLayout>
    );
  }
}

export default withRouter(ViewSpacePageBase);
